"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M4 12c0 4.07 3.06 7.44 7 7.93V4.07C7.06 4.56 4 7.93 4 12m9 7.93c3.61-.45 6.48-3.32 6.93-6.93H13zm0-15.86V11h6.93c-.45-3.61-3.32-6.48-6.93-6.93",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-1 17.93c-3.94-.49-7-3.86-7-7.93s3.06-7.44 7-7.93zm2 0V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93M13 11V4.07c3.61.45 6.48 3.32 6.93 6.93z"
}, "1")], 'PieChartTwoTone');